import React, { Component } from "react";
import styled from "styled-components";

import { ActionPermissionsObject, PermissionActionType } from "common/interfaces";
import WorkspaceController from "js/controllers/WorkspaceController";
import { trackActivity } from "js/core/utilities/utilities";
import { ShowUpgradeDialog } from "js/react/components/Dialogs/BaseDialog";
import { Gap20 } from "js/react/components/Gap";
import ProBadge from "js/react/components/ProBadge";
import { UIPane, UIPaneContents, UIPaneHeader, YellowButton } from "js/react/components/UiComponents";
import AnalyticsController from "js/react/views/Analytics/AnalyticsController";
import { UpgradePlanDialogType } from "js/react/views/MarketingDialogs/UpgradePlanDialog";

import AnalyticsTabs from "../Components/AnalyticsTabs";
import { PresentationStats } from "../Components/Stats";
import ViewingAggregates from "../Components/ViewingAggregates";
import ViewsPerDay from "../Components/ViewsPerDay";

// Needed to ensure the chart sections resize with the window properly
const AbsoluteFrame = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
`;

const ContentsBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

const StyledUIPaneContents = styled(UIPaneContents)`
    height: calc(100% - 75px);
`;

class AnalyticsPane extends Component {
    tabsOnClickHandler = tabValue => {
        const analyticsProps = {
            presentation_id: this.props.presentation.get("id"),
            view_selected: tabValue.replace(" ", "")
        };
        trackActivity("PresentationAnalytics", "ToggleView", null, null, analyticsProps);
    };

    handleShowProDialogAnalytics = () => {
        const { presentation } = this.props;

        ShowUpgradeDialog({
            type: UpgradePlanDialogType.UPGRADE_PLAN,
            analytics: { cta: "Analytics", ...presentation.getAnalytics() },
            workspaceId: presentation.getWorkspaceId()
        });
    }

    render() {
        const workspaceId = this.props.presentation.getWorkspaceId();

        const canUpgrade = WorkspaceController.canUpgradeToRemoveActionRestriction(ActionPermissionsObject.ANALYTICS, PermissionActionType.USE);
        const canUse = WorkspaceController.actionPermissions[ActionPermissionsObject.ANALYTICS].use;

        const analytics = { cta: "Analytics", ...this.props.presentation.getAnalytics() };

        return (
            <UIPane className="player_analytics overview-page">
                <AbsoluteFrame>
                    <UIPaneHeader>
                        Analytics
                        <ProBadge
                            show={canUpgrade}
                            workspaceId={this.props.presentation.getWorkspaceId()}
                            analytics={analytics}
                        />
                    </UIPaneHeader>
                    <StyledUIPaneContents>
                        <Gap20 />
                        {canUpgrade && (
                            <div className="analytics-upgrade-banner">
                                Get analytics and detailed data about who and when people are viewing your presentations.
                                <YellowButton
                                    onClick={() =>
                                        ShowUpgradeDialog({
                                            type: UpgradePlanDialogType.UPGRADE_PLAN,
                                            analytics,
                                            workspaceId
                                        })
                                    }
                                >
                                    Upgrade Plan
                                </YellowButton>
                            </div>
                        )}

                        <ContentsBlock style={!canUse ? { pointerEvents: "none" } : {}}>
                            <ViewsPerDay />
                            <PresentationStats />
                            <ViewingAggregates />
                            <AnalyticsTabs parentOnClickHandler={this.tabsOnClickHandler} />
                        </ContentsBlock>
                        {canUpgrade && (
                            <div className="analytics-upgrade-shield">
                                <div style={{ pointerEvents: "all" }} onClick={this.handleShowProDialogAnalytics}>Sample Data</div>
                            </div>
                        )}
                    </StyledUIPaneContents>
                </AbsoluteFrame>
            </UIPane>
        );
    }
}

export default AnalyticsController.withState(AnalyticsPane);
